import React, { useEffect, useState, useRef } from "react";
import {
    Table,
    Tag,
    Card,
    Button,
    Space,
    Form,
    Input,
} from "antd";
import {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import useMessage from "antd/es/message/useMessage";
import { LetterService } from "../../../../Services/Manage/LetterService";
import { UserService } from "../../../../Services/Manage/UserService";
import CreateDepartment from "./CreateDepartment";
import { DepartmentEmpServices } from "../../../../Services/Manage/DepartmentEmpServices";

const DepartmentPage = () => {
    const originalData = useRef([]);
    const [filteredData, setFilteredData] = useState([]);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [form] = Form.useForm();
    const [messageApi, messageContxt] = useMessage();

    const statusColors = {
        Inactive: "red",
        Active: "green",
    };

    const getAllLetterhead = async () => {
        try {
            const request = await DepartmentEmpServices.getAllDepartment();
            const mapped = request.data.map((item, index) => ({
                ...item,
                si_no: index + 1,
            }));
            originalData.current = mapped;
            if (searchText) {
                const filtered = mapped.filter((item) =>
                    Object.values(item).some(
                        (val) =>
                            val && typeof val === 'string' && val.toLowerCase().includes(searchText.toLowerCase())
                    )
                );
                setFilteredData(filtered);
            } else {
                setFilteredData(mapped);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getAllLetterhead();
    }, []);

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchText(value);
        const filtered = originalData.current.filter((item) =>
            Object.values(item).some(
                (val) =>
                    val && typeof val === 'string' && val.toLowerCase().includes(value.toLowerCase())
            )
        );
        setFilteredData(filtered);
    };

    const columns = [
        {
            title: "S. No.",
            dataIndex: "si_no",
            key: "si_no",
            align: 'center'
        },
        {
            title: "Department Name",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => (
                <Tag
                    style={{ fontSize: "16px", padding: "6px 12px" }}
                    color={statusColors[status]}>{status.toUpperCase()}</Tag>
            ),
        },
        {
            title: "Actions",
            key: "actions",
            fixed: 'right',
            render: (text, record) => (
                <Space size="middle">
                    <Button
                        size="large"
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record)}
                    />
                    <Button
                        size="large"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(record)}
                    />
                </Space>
            ),
        },
    ];

    const showDrawer = () => {
        setEditingItem(null);
        form.resetFields();
        setDrawerVisible(true);
    };

    const handleEdit = async (record) => {
        setEditingItem(record);
        const user = await UserService.getOmeUser();
        form.setFieldsValue({
            ...record,
            added_by: user.uid,
            status: record.status === "Active",
        });
        setDrawerVisible(true);
    };

    const handleDelete = async (record) => {
        try {
            const request = await DepartmentEmpServices.deleteDepartment(record.id);
            if (request.status) {
                messageApi.success(request.message);
                getAllLetterhead();
            } else {
                messageApi.error(request.message);
            }
        } catch (error) {
            console.log(error);
            messageApi.warning(error);
        }
    };

    const handleDrawerClose = () => {
        setDrawerVisible(false);
        form.resetFields();
    };

    const onFinish = async (values) => {
        const user = await UserService.getOmeUser();
        const newItem = {
            ...values,
            added_by: user.uid,
            status: values.status ? "Active" : "Inactive",
        };

        if (editingItem) {
            console.log(newItem);

            const request = await DepartmentEmpServices.updateDepartment(newItem, editingItem.id);
            if (request.status) {
                messageApi.success(request.message);
                getAllLetterhead();
            } else {
                messageApi.error(request.message);
            }
        } else {
            console.log(newItem);

            const request = await DepartmentEmpServices.createDepartment(newItem);
            if (request.status) {
                messageApi.success(request.message);
                getAllLetterhead();
            } else {
                messageApi.error(request.message);
            }
        }

        setDrawerVisible(false);
        form.resetFields();
    };


    return (
        <div>
            <Card
                title="Manage Departments"
                extra={
                    <Space>
                        <Input
                            size='large'
                            placeholder="Search..."
                            prefix={<SearchOutlined />}
                            value={searchText}
                            onChange={handleSearch}
                            style={{ width: 300 }}
                            allowClear
                        />
                        <Button
                            type="primary"
                            size="large"
                            icon={<PlusOutlined />}
                            onClick={showDrawer}
                        >
                            Add Department
                        </Button>
                    </Space>
                }
            >
                <Table
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{ pageSize: 10 }}
                    scroll={{ x: true }}
                />
            </Card>
            {messageContxt}

            <CreateDepartment
                visible={drawerVisible}
                onClose={handleDrawerClose}
                onFinish={onFinish}
                form={form}
                editingItem={editingItem}
            />
        </div>
    );
};

export default DepartmentPage;